<template>
<v-container fluid style="max-width: 1280px;">

    <v-row no-gutters class="mb-2">
        <v-col cols="12">
            <im-title-bar :title="availability.hotel.name" />
        </v-col>
    </v-row>


    <v-card outlined class="ma-2">
        <v-card-text class="text-center">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-icon color="success" style="font-size: 64px">
                        check_circle_outline
                    </v-icon>
                </v-col>
                <v-col cols="12">
                    <span class="headline">
                        Rezervarea nr. <strong>{{reservation.code}}</strong> s-a confirmat.<br>
                    </span>
                </v-col>
                <v-col cols="12">
                    <span class="title">
                        Vă mulțumim pentru rezervarea efectuată.<br>
                        Am trimis confirmarea prin e-mail la adresa <strong>{{reservation.order.customer.email}}</strong> .
                    </span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>


    <div class="my-3"></div>


    <v-card outlined class="ma-2">
        <v-card-title class="headline">
            Sumar rezervare
        </v-card-title>
        <v-card-text>

            <v-row no-gutters>
                <v-col cols="12">
                    <div class="title">
                        Informatii
                    </div>
                </v-col>
                <v-col cols="6">
                    Durata rezervarii
                </v-col>
                <v-col cols="6 text-right">
                    {{ availability.check_in }}
                    <v-icon small>arrow_right</v-icon>
                    {{ availability.check_out }}
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col cols="6">
                    Numărul rezervării:
                </v-col>
                <v-col cols="6" class="text-right">
                    {{reservation.code}}
                </v-col>

            </v-row>


            <v-divider class="my-3" />


            <v-row no-gutters>
                <v-col cols="12">
                    <div class="title">Inventar</div>
                    <div v-for="(room, room_index) in reservation.rooms" :key="'reservation_room_' + room_index">
                        <div>
                            <v-row no-gutters>
                                <v-col cols="8" class="text-left subtitle-1 font-weight-bold">
                                    1 <small>x</small> {{room.room_type_name}}
                                </v-col>

                                <v-col cols="4" class="text-right subtitle-1">
                                    <im-price :price="room.total_price" :currency="reservation.currency" :font-size="16" />
                                </v-col>

                                <v-col class="mt-n2 mb-2">
                                    {{room.rate_plan_name}}
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row no-gutters align="center">
                <v-col class="title text-right">
                    Total:
                    <im-price :font-size="20" :price="reservation.total_price" :currency="reservation.currency" />
                </v-col>
            </v-row>


            <v-divider class="my-3" />


            <v-row no-gutters>
                <v-col cols="12">
                    <div class="title">Solicitant</div>
                </v-col>
                <v-col cols="6">
                    Nume
                </v-col>
                <v-col cols="6" class="text-right">
                    {{reservation.order.customer.first_name}} {{reservation.order.customer.last_name}}
                </v-col>
                <v-col cols="6">
                    Email
                </v-col>
                <v-col cols="6" class="text-right">
                    {{reservation.order.customer.email}}
                </v-col>
                <v-col cols="6">
                    Telefon
                </v-col>
                <v-col cols="6" class="text-right">
                    {{reservation.order.customer.phone}}
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    <v-card outlined class="ma-2">
        <v-card-text class="text-center">
            Vă dorim un sejur plăcut!<br>
            E-mail: rezervari@helloromania.com<br>
            Telefon: (+40) 212 700 090
        </v-card-text>
    </v-card>


</v-container>
</template>

<script>
import IMTitleBar from '../components/items/TitleBar.vue';
import IMPrice from "../components/utils/IMPrice";

export default {

    components: {
        'im-title-bar': IMTitleBar,
        'im-price': IMPrice,
    },

    data: () => ({
        // hotel: JSON.parse(sessionStorage.getItem('hotel')),
        availability: JSON.parse(sessionStorage.getItem('availability')),
        reservation: JSON.parse(sessionStorage.getItem('reservation'))
    }),

    created() {
        console.log("confirmation", this.$route);
    },

    methods: {

        getIntervalInDays(check_in, check_out) {
            let date1 = this.$moment(check_in);
            let date2 = this.$moment(check_out);

            return date2.diff(date1, 'days');
        },

        getPriceCurrency() {
            return this.availability.currency;
        },

        getPriceTotal() {
            let total_price = 0;
            this.availability.rooms.forEach(room => {
                room.prices.forEach(rate => {
                    if(rate.quantity > 0) {
                        total_price += rate.price * rate.quantity;
                    }
                });
            });

            return total_price;
        },
    }

}
</script>
